import { render, staticRenderFns } from "./floorplan.vue?vue&type=template&id=0c0b4b8c&"
import script from "./floorplan.vue?vue&type=script&lang=js&"
export * from "./floorplan.vue?vue&type=script&lang=js&"
import style0 from "./floorplan.vue?vue&type=style&index=0&id=0c0b4b8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports